import React, { useEffect, useMemo, useRef, useState } from 'react';
import './App.css';
import './LandingPage.css';
import './kioskTheme.css';
import Carousel from './Carousel';
import slide1 from './assets/slide1.png';
import slide3 from './assets/slide3.png';
import foxHero from './assets/fox-money.png';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from './languageContext';
import LanguageToggle from './LanguageToggle';
import { FullPageLoader, useRouteEntryLoader } from './navigationLoader';

// Idle time on the start page before the attract-loop carousel takes over.
const IDLE_CAROUSEL_DELAY = 5 * 60 * 1000;

// A customer mid-journey (logged in, or with a saved application) must never be covered by the
// attract loop, even if the kiosk is left idling on the start page.
const isLoanJourneyInProgress = () => {
  try {
    const token = String(localStorage.getItem('token') || '').trim();
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const hasSession = Boolean(token && user && typeof user === 'object' && Object.keys(user).length > 0);
    const hasSavedApplication = Boolean(String(localStorage.getItem('loan_application_saved_state') || '').trim());
    return hasSession || hasSavedApplication;
  } catch (_error) {
    return false;
  }
};

const TRANSLATIONS = {
  en: {
    headingLine1: 'Instant Loans',
    headingLine2: 'for Salaried Professionals',
    subtitle: 'Zero Paperwork. 100% Digital.',
    applyNow: 'APPLY NOW',
    tagline: 'Your Goals, Our Support',
    trust: {
      rewards: 'Exciting Rewards',
      process: 'Fast & Easy Process',
      safety: 'Your Data is Safe with Us',
      digital: '100% Digital'
    },
    luckyDraw: 'Lucky Draw',
    spinTitle: 'Spin & Win!',
    spinSub: 'Win cashback, fee cuts, and surprise perks in one quick spin.',
    spinning: 'Spinning...',
    rewardLocked: 'Reward Locked In',
    spinNow: 'Spin Now',
    youWon: 'You won:',
    modalTitle: 'You Won!',
    modalDescLine1: 'Your reward is applied automatically.',
    modalDescLine2: 'Apply for a loan to redeem it!',
    modalApply: 'Apply Now ->',
    close: 'Close',
    slides: [
      { image: process.env.PUBLIC_URL + '/nbfc1.png' },
      { image: slide3, text: 'No CIBIL Required \n Apply now' },
      // { image: process.env.PUBLIC_URL + '/image3_corporate_final.png', text: 'Zero Paperwork for Salaried Employees \n Apply now' },
      { image: process.env.PUBLIC_URL + '/diwalitheme.png', text: 'Brighten your celebrations with simple, quick, and trusted disbursals this Diwali.\n Apply now' },
      { image: process.env.PUBLIC_URL + '/depressed1.png', text: 'Expenses More Than Salary? Get a Top-up instantly! \n Apply now' },
      { image: slide1, text: 'Upgrade Your Lifestyle Today \n Apply now' },
      { image: process.env.PUBLIC_URL + '/travling.jpg', text: 'Salary khatam ho gayi,Pahado pe jana hai \n Apply now' },
      { image: process.env.PUBLIC_URL + '/indian_parents.png', text: 'Salary khatam ho gayi! \n Mummy papa ko anniversary gift Dena hai? \n Apply now' },
      { image: process.env.PUBLIC_URL + '/Dating+blog1.webp', text: 'Salary khatam ho gayi! \n Date pe jana hai \n Apply now' },
      { image: process.env.PUBLIC_URL + '/birthday3.png', text: 'Apke bacche ka birthday hai \n Salary khatam ho gayi \n Apply now' },
      { image: process.env.PUBLIC_URL + '/school.jpg', text: 'Bacche ki school fees bharni hai? \n Salary khatam ho gayi \n Apply now' },
      { image: process.env.PUBLIC_URL + '/hospital1.png', text: 'Medical Emergency? \n We are here to help \n Apply now' },
      { image: process.env.PUBLIC_URL + '/loan_rejection1.png', text: "Loan Rejection se Pareshan Don't worry meri jaan? \n Apply now" },
      { image: process.env.PUBLIC_URL + '/Insurance_Due.png', text: 'Insurance Premium due Pareshan Kyu? \n Apply now' }
    ],
    segmentLabels: {
      fee5: '5%\nProcessing\nFee',
      fee10: '10%\nProcessing\nFee',
      fee15: '15%\nProcessing\nFee',
      fee20: '20%\nProcessing\nFee'
    }
  },
  hi: {
    headingLine1: 'सैलरीड प्रोफेशनल्स के लिए',
    headingLine2: 'इंस्टेंट लोन',
    subtitle: 'जीरो पेपरवर्क। 100% डिजिटल।',
    applyNow: 'अभी अप्लाई करें',
    tagline: 'आपके लक्ष्य, हमारा साथ',
    trust: {
      rewards: 'शानदार रिवॉर्ड',
      process: 'तेज़ और आसान प्रक्रिया',
      safety: 'आपका डेटा हमारे पास सुरक्षित',
      digital: '100% डिजिटल'
    },
    luckyDraw: 'लकी ड्रॉ',
    spinTitle: 'स्पिन करो और जीतों!',
    spinSub: 'एक स्पिन में कैशबैक, प्रोसेसिंग फी छूट और सरप्राइज फायदे पाएं।',
    spinning: 'स्पिन हो रहा है...',
    rewardLocked: 'रिवॉर्ड लॉक हो गया',
    spinNow: 'अभी स्पिन करें',
    youWon: 'आपने जीता:',
    modalTitle: 'बधाई हो!',
    modalDescLine1: 'आपका रिवॉर्ड अपने आप लागू हो गया है।',
    modalDescLine2: 'इसे पाने के लिए लोन अप्लाई करें!',
    modalApply: 'अभी अप्लाई करें ->',
    close: 'बंद करें',
    slides: [
      { image: process.env.PUBLIC_URL + '/nbfc.jpeg' },
      { image: slide3, text: 'CIBIL की जरूरत नहीं \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/image3_corporate_final.png', text: 'सैलरीड कर्मचारियों के लिए जीरो पेपरवर्क \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/Rahul_Sir1.png', text: 'आसान प्रक्रिया। तेज डिस्बर्सल। प्रोफेशनल्स का भरोसा। \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/Depresd.png', text: 'खर्च सैलरी से ज्यादा? तुरंत टॉप-अप लें! \n अभी अप्लाई करें' },
      { image: slide1, text: 'आज ही अपनी लाइफस्टाइल अपग्रेड करें \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/travling.jpg', text: 'सैलरी खत्म हो गई, पहाड़ों पर जाना है \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/indian_parents.png', text: 'सैलरी खत्म हो गई! \n मम्मी-पापा को एनिवर्सरी गिफ्ट देना है? \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/Dating+blog1.webp', text: 'सैलरी खत्म हो गई! \n डेट पर जाना है \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/Birthday2.png', text: 'आपके बच्चे का जन्मदिन है \n सैलरी खत्म हो गई \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/school.jpg', text: 'बच्चे की स्कूल फीस भरनी है? \n सैलरी खत्म हो गई \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/hospital.jpg', text: 'मेडिकल इमरजेंसी? \n हम आपकी मदद के लिए हैं \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/loan_rejection.png', text: 'लोन रिजेक्शन से परेशान? चिंता मत करो मेरी जान \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/Insurance_Due.png', text: 'इंश्योरेंस प्रीमियम ड्यू है? परेशान क्यों? \n अभी अप्लाई करें' }
    ],
    segmentLabels: {
      fee5: '5%\nप्रोसेसिंग\nफीस',
      fee10: '10%\nप्रोसेसिंग\nफीस',
      fee15: '15%\nप्रोसेसिंग\nफीस',
      fee20: '20%\nप्रोसेसिंग\nफीस'
    }
  }
};

const SEGMENT_META = [
  { key: 'fee5', percent: 5, color: '#ef4444', textColor: '#fff', emoji: '🎁' },
  { key: 'fee10', percent: 10, color: '#3b82f6', textColor: '#fff', emoji: '🎁' },
  { key: 'fee15', percent: 15, color: '#10b981', textColor: '#fff', emoji: '🎁' },
  { key: 'fee20', percent: 20, color: '#f59e0b', textColor: '#fff', emoji: '🎁' }
];

const WHEEL_RIM_BULBS = 16;
const WHEEL_LABEL_FONT = "800 30px 'Nunito'";

// Outline icons for the trust strip, keyed by the `trust` translation keys.
const TRUST_ICONS = {
  rewards: (
    <>
      <rect x="3" y="8" width="18" height="4" rx="1" />
      <path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
      <path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5" />
    </>
  ),
  process: <path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z" />,
  safety: (
    <>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  digital: (
    <>
      <rect x="5" y="2" width="14" height="20" rx="2.5" />
      <path d="M11 18h2" />
    </>
  )
};

const TRUST_KEYS = Object.keys(TRUST_ICONS);

function TrustIcon({ name }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {TRUST_ICONS[name]}
    </svg>
  );
}

function LandingPage() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = TRANSLATIONS[language] || TRANSLATIONS.en;
  const entryLoaderMessage = useRouteEntryLoader('Opening start page...');

  const slides = useMemo(() => t.slides, [t]);
  const segments = useMemo(
    () =>
      SEGMENT_META.map((segment) => ({
        ...segment,
        label: t.segmentLabels[segment.key]
      })),
    [t]
  );

  const getLandingWheelSize = () => {
    const isPortrait = window.innerHeight > window.innerWidth;
    if (isPortrait) {
      return Math.max(700, Math.min(900, Math.floor(window.innerWidth * 0.95)));
    }

    return 700;
  };

  // Spin state
  const canvasRef = useRef(null);
  const spinRef = useRef({ rotation: 0, rafId: null });
  const idleTimerRef = useRef(null);
  const [isSpinning, setIsSpinning] = useState(false);
  const [hasSpun, setHasSpun] = useState(false);
  const [spinResult, setSpinResult] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [wheelSize, setWheelSize] = useState(() => getLandingWheelSize());
  const [showIdleCarousel, setShowIdleCarousel] = useState(false);

  const drawWheel = (rotation) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const size = canvas.width;
    const cx = size / 2;
    const cy = size / 2;
    const outerR = cx - 4;
    const rimWidth = size * 0.05;
    const r = outerR - rimWidth;
    const n = segments.length;
    const arc = (2 * Math.PI) / n;

    ctx.clearRect(0, 0, size, size);

    // Golden rim
    const rim = ctx.createLinearGradient(0, 0, 0, size);
    rim.addColorStop(0, '#fde68a');
    rim.addColorStop(0.5, '#fbbf24');
    rim.addColorStop(1, '#f59e0b');
    ctx.beginPath();
    ctx.arc(cx, cy, outerR, 0, 2 * Math.PI);
    ctx.fillStyle = rim;
    ctx.fill();

    // Segments
    segments.forEach((seg, i) => {
      const start = rotation + i * arc;

      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.arc(cx, cy, r, start, start + arc);
      ctx.closePath();
      ctx.fillStyle = seg.color;
      ctx.fill();
      ctx.strokeStyle = 'rgba(255,255,255,0.7)';
      ctx.lineWidth = Math.max(2, size * 0.004);
      ctx.stroke();
    });

    // Soft top-light sheen for depth
    const sheen = ctx.createRadialGradient(cx, cy - r * 0.4, r * 0.1, cx, cy, r);
    sheen.addColorStop(0, 'rgba(255,255,255,0.2)');
    sheen.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, 2 * Math.PI);
    ctx.fillStyle = sheen;
    ctx.fill();

    // Inner rim edge
    ctx.strokeStyle = 'rgba(180,83,9,0.3)';
    ctx.lineWidth = Math.max(2, size * 0.006);
    ctx.stroke();

    // Labels
    segments.forEach((seg, i) => {
      const mid = rotation + i * arc + arc / 2;

      ctx.save();
      ctx.translate(cx + Math.cos(mid) * r * 0.58, cy + Math.sin(mid) * r * 0.58);
      ctx.rotate(mid + Math.PI / 2);
      ctx.shadowColor = 'rgba(15, 23, 42, 0.35)';
      ctx.shadowBlur = 6;
      ctx.shadowOffsetY = 2;
      ctx.fillStyle = seg.textColor;
      ctx.font = `800 ${size * 0.043}px Nunito, 'Segoe UI', Arial, sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      seg.label.split('\n').forEach((ln, li, arr) => {
        const y = (li - (arr.length - 1) / 2) * size * 0.052;
        ctx.fillText(ln, 0, y);
      });
      ctx.restore();
    });

    // Rim bulbs (fixed, so they read as part of the frame)
    const bulbOrbit = outerR - rimWidth / 2;
    ctx.save();
    ctx.shadowColor = 'rgba(255,255,255,0.9)';
    ctx.shadowBlur = size * 0.012;
    ctx.fillStyle = '#fffbeb';
    for (let i = 0; i < WHEEL_RIM_BULBS; i += 1) {
      const angle = (i / WHEEL_RIM_BULBS) * 2 * Math.PI;
      ctx.beginPath();
      ctx.arc(cx + Math.cos(angle) * bulbOrbit, cy + Math.sin(angle) * bulbOrbit, rimWidth * 0.17, 0, 2 * Math.PI);
      ctx.fill();
    }
    ctx.restore();

    // Hub
    const hubR = r * 0.12;
    ctx.save();
    ctx.shadowColor = 'rgba(15, 23, 42, 0.25)';
    ctx.shadowBlur = size * 0.02;
    ctx.shadowOffsetY = size * 0.006;
    ctx.beginPath();
    ctx.arc(cx, cy, hubR, 0, 2 * Math.PI);
    ctx.fillStyle = '#fbbf24';
    ctx.fill();
    ctx.restore();

    const hub = ctx.createRadialGradient(cx - hubR * 0.3, cy - hubR * 0.3, 0, cx, cy, hubR * 0.78);
    hub.addColorStop(0, '#ffffff');
    hub.addColorStop(1, '#f1f5f9');
    ctx.beginPath();
    ctx.arc(cx, cy, hubR * 0.78, 0, 2 * Math.PI);
    ctx.fillStyle = hub;
    ctx.fill();
  };

  useEffect(() => {
    const resetIdleTimer = () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
      setShowIdleCarousel(false);
      idleTimerRef.current = setTimeout(() => {
        if (isLoanJourneyInProgress()) {
          // Someone is still inside a journey: stay quiet and look again after another idle window.
          resetIdleTimer();
          return;
        }
        setShowIdleCarousel(true);
        // Dismiss the spin result popup so it isn't left open for the next visitor
        setShowResult(false);
      }, IDLE_CAROUSEL_DELAY);
    };

    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    events.forEach((eventName) => window.addEventListener(eventName, resetIdleTimer));
    resetIdleTimer();

    return () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
      events.forEach((eventName) => window.removeEventListener(eventName, resetIdleTimer));
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setWheelSize(getLandingWheelSize());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    drawWheel(spinRef.current.rotation);
    const ref = spinRef.current;
    return () => cancelAnimationFrame(ref.rafId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wheelSize, segments]);

  // Canvas text doesn't re-render on font load, so redraw once the web font is ready.
  useEffect(() => {
    if (!document.fonts) return undefined;
    let active = true;
    document.fonts.load(WHEEL_LABEL_FONT).then(() => {
      if (active) drawWheel(spinRef.current.rotation);
    }).catch(() => { });
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [segments]);

  const handleSpin = () => {
    if (isSpinning || hasSpun) return;
    setIsSpinning(true);

    const n = segments.length;
    const fullCircle = 2 * Math.PI;
    const arc = (2 * Math.PI) / n;
    const winIdx = Math.floor(Math.random() * n);
    const start = spinRef.current.rotation;
    const normalizedStart = ((start % fullCircle) + fullCircle) % fullCircle;
    const winnerCenterAtTop = -Math.PI / 2 - (winIdx * arc + arc / 2);
    const normalizedTarget = ((winnerCenterAtTop % fullCircle) + fullCircle) % fullCircle;
    const deltaToTarget = normalizedTarget - normalizedStart;
    const positiveDelta = deltaToTarget >= 0 ? deltaToTarget : deltaToTarget + fullCircle;
    const delta = 5 * fullCircle + positiveDelta;
    const dur = 4200;
    let t0 = null;
    const easeOut = (time) => 1 - Math.pow(1 - time, 4);

    const tick = (ts) => {
      if (!t0) t0 = ts;
      const p = Math.min((ts - t0) / dur, 1);
      const angle = start + delta * easeOut(p);
      spinRef.current.rotation = angle;
      drawWheel(angle);
      if (p < 1) {
        spinRef.current.rafId = requestAnimationFrame(tick);
      } else {
        setIsSpinning(false);
        setHasSpun(true);
        const wonSegment = segments[winIdx];
        setSpinResult(wonSegment);

        if (wonSegment.percent) {
          localStorage.setItem('spin_reward_fee_discount_percent', String(wonSegment.percent));
        } else {
          localStorage.removeItem('spin_reward_fee_discount_percent');
        }
        // legacy flag from the old fixed-20%-only wheel, kept clear so it can't override the new reward
        localStorage.removeItem('spin_reward_20_percent_fee');

        setShowResult(true);
      }
    };
    spinRef.current.rafId = requestAnimationFrame(tick);
  };

  const handleApplyNow = () => navigate('/login');

  return (
    <div className="kiosk-container kiosk-theme lp-page">
      {entryLoaderMessage && <FullPageLoader message={entryLoaderMessage} />}
      <div className="kiosk-bottom">
        <div className="lp-inner">
          <div className="lp-cta">
            <div className="lp-topbar">
              {!showIdleCarousel && <LanguageToggle />}
              <p className="lp-tagline">{t.tagline}</p>
            </div>
            <div className="lp-hero">
              <div className="lp-hero-media" aria-hidden="true">
                <img className="lp-hero-fox" src={foxHero} alt="" />
              </div>
              <div className="lp-hero-copy">
                <h1>
                  <span className="lp-hero-title-lead">{t.headingLine1}</span>
                  <br />
                  {t.headingLine2}
                </h1>
                <p className="subtitle">{t.subtitle}</p>

                <button
                  type="button"
                  className="primary-btn landing-apply-btn"
                  onClick={handleApplyNow}
                >
                  {t.applyNow}
                </button>
              </div>
            </div>

            <div className="lp-spin">
              <div className="lp-spin-header">
                <span className="lp-spin-badge">🎁 {t.luckyDraw}</span>
                <p className="lp-spin-title">{t.spinTitle}</p>
                <p className="lp-spin-sub">{t.spinSub}</p>
              </div>

              <div className="lp-spin-arena">
                <div className="lp-spin-pointer">▼</div>
                <div className="lp-spin-spark lp-spin-spark-a" />
                <div className="lp-spin-spark lp-spin-spark-b" />
                <div className="lp-spin-spark lp-spin-spark-c" />
                <div className="lp-spin-ring">
                  <canvas
                    ref={canvasRef}
                    width={wheelSize}
                    height={wheelSize}
                    className="lp-spin-canvas"
                  />
                </div>
              </div>

              <button
                type="button"
                className={`lp-spin-btn${isSpinning ? ' spinning' : ''}${hasSpun ? ' spun' : ''}`}
                onClick={handleSpin}
                disabled={isSpinning || hasSpun}
              >
                <span className="lp-spin-mascot" aria-hidden="true">
                  <video
                    className="lp-spin-mascot-media"
                    src={`${process.env.PUBLIC_URL}/fox.webm`}
                    poster={`${process.env.PUBLIC_URL}/dancing-fox.png`}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="metadata"
                    style={{
                      opacity: 1,
                      transition: 'opacity 0.5s ease'
                    }}
                  />
                </span>
                <span className="lp-spin-btn-copy">
                  {isSpinning ? t.spinning : hasSpun ? t.rewardLocked : t.spinNow}
                </span>
                <span className="lp-spin-arrow" aria-hidden="true">→</span>
              </button>

              {hasSpun && !showResult && spinResult && (
                <div className="lp-spin-teaser-container">
                  <p className="lp-spin-teaser">
                    {t.youWon} <strong>{spinResult.emoji} {spinResult.label.replace('\n', ' ')}</strong>
                  </p>
                </div>
              )}

              <ul className="lp-trust">
                {TRUST_KEYS.map((key) => (
                  <li key={key} className="lp-trust-item">
                    <span className="lp-trust-icon">
                      <TrustIcon name={key} />
                    </span>
                    <strong>{t.trust[key]}</strong>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {showIdleCarousel && (
        <div className="idle-carousel-overlay" role="presentation">
          <Carousel slides={slides} interval={4000} />
        </div>
      )}

      {showResult && spinResult && (
        <div className="lp-overlay" onClick={() => setShowResult(false)}>
          <div className="lp-result-box" onClick={(e) => e.stopPropagation()}>
            <div className="lp-result-emoji">{spinResult.emoji}</div>
            <h2 className="lp-result-title">{t.modalTitle}</h2>
            <div className="lp-result-prize" style={{ background: spinResult.color }}>
              {spinResult.label.replace('\n', ' ')}
            </div>
            <p className="lp-result-desc">
              {t.modalDescLine1}<br />{t.modalDescLine2}
            </p>
            <button className="lp-result-cta" onClick={() => { setShowResult(false); navigate('/login'); }}>
              {t.modalApply}
            </button>
            <button className="lp-result-close" onClick={() => setShowResult(false)}>
              {t.close}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default LandingPage;
